import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'dateTransform'
})
export class DateTransformPipe implements PipeTransform {
  transform(value: string | null, args?: any): any {
  return value?.slice(8, 10) + '.' + value?.slice(5, 7) + '.' + value?.slice(0, 4) + ' ' + value?.slice(11, 16);
  }
}
